import React, { useState } from "react";
import Header from "./Components/Header";
import bookingData from "./data/bookingData.json";
import { CLASS_BOOKING } from "../../assets/asset";
import { ChevronLeft, ChevronRight, Calendar, Clock } from "lucide-react";
import { useNavigate } from "react-router-dom";
import PageContainer from "./Components/PageContainer";
import MainContent from "./Components/MainContent";
import BackButton from "./Components/BackButton";
import BookingSummary from "./Components/BookingSummary";
import PaymentModal from "./Components/PaymentModal";

const BookingPage = () => {
  const navigate = useNavigate();

  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  const month = "December 2025";
  const daysInMonth = Array.from({ length: 31 }, (_, i) => i + 1);
  const availableDates = bookingData.availableDates;
  const timeSlots = bookingData.timeSlots;

  const isAvailable = (day) => availableDates.includes(day);
  const isPaymentEnabled = selectedDate && selectedTime;

  const tutor = bookingData.tutor;

  const formattedDate = selectedDate
    ? `Friday, ${selectedDate} December, 2025`
    : "Not selected";

  const handleContinueToPayment = () => {
    if (isPaymentEnabled) {
      setShowPopup(true);
    }
  };

  const handleConfirmPayment = () => {
    alert("Payment Successful");
    setShowPopup(false);
  };

  return (
    <PageContainer>
 <div className="sticky top-0 z-50 bg-[#DFF2EB]/70 backdrop-blur-md">
  <Header />
</div>


      <MainContent className="pb-20 px-12">
        <div className="bg-transparent border-2 border-white rounded-2xl shadow-xl w-full max-w-7xl p-12 mt-10 backdrop-blur-[2px]">
          <BackButton onClick={() => window.history.back()} label="Back to Profile" />

          <div className="grid grid-cols-3 gap-10">
            <div className="col-span-2">
              <h2 className="text-xl font-semibold text-gray-900">Select Date & Time</h2>
              <p className="text-gray-600 mt-1 mb-6">
                Choose an available slot with {tutor.name}
              </p>

              <div className="bg-white rounded-2xl p-8 shadow-md border border-gray-200">
                <div className="flex items-center gap-2 text-gray-800 font-medium">
                  <Calendar size={20} />
                  Select Date
                </div>

                <div className="flex justify-between items-center mt-6">
                  <button className="p-2 bg-gray-100 rounded-full">
                    <ChevronLeft size={18} className="text-gray-600" />
                  </button>

                  <h3 className="text-lg font-semibold">{month}</h3>

                  <button className="p-2 bg-[#0736D6] rounded-full">
                    <ChevronRight size={18} className="text-white" />
                  </button>
                </div>

                <div className="grid grid-cols-7 text-center text-gray-500 font-medium mt-6">
                  <span>Sun</span><span>Mon</span><span>Tue</span><span>Wed</span>
                  <span>Thu</span><span>Fri</span><span>Sat</span>
                </div>

                <div className="grid grid-cols-7 text-center mt-4 gap-y-4">
                  {daysInMonth.map((day) => {
                    const available = isAvailable(day);
                    const selected = selectedDate === day;

                    return (
                      <button
                        key={day}
                        disabled={!available}
                        onClick={() => {
                          setSelectedDate(day);
                          setSelectedTime(null);
                        }}
                        className={`
                          w-10 h-10 flex items-center justify-center rounded-full mx-auto transition
                          ${available ? "bg-gray-100 text-gray-800 hover:bg-gray-200" : "text-gray-300"}
                          ${selected ? "bg-[#0736D6] text-white" : ""}
                        `}
                      >
                        {day}
                      </button>
                    );
                  })}
                </div>

                {selectedDate && (
                  <>
                    <div className="mt-10 mb-3 flex items-center gap-2 text-gray-700 font-medium">
                      <Clock size={18} /> Available Times
                    </div>

                    <div className="flex gap-4 flex-wrap">
                      {timeSlots.map((time, i) => (
                        <button
                          key={i}
                          onClick={() => setSelectedTime(time)}
                          className={`
                            px-6 py-2 rounded-xl border text-sm transition
                            ${
                              selectedTime === time
                                ? "border-[#0736D6] bg-[#EAEFFF] text-[#0736D6] font-semibold"
                                : "border-gray-300 text-gray-700 bg-white hover:bg-gray-100"
                            }
                          `}
                        >
                          {time}
                        </button>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="col-span-1">
              <BookingSummary 
                tutor={tutor}
                selectedDate={selectedDate}
                selectedTime={selectedTime}
                formattedDate={formattedDate}
                onContinue={handleContinueToPayment}
                isPaymentEnabled={isPaymentEnabled}
              />
            </div>
          </div>
        </div>
      </MainContent>

      {showPopup && (
        <PaymentModal 
          tutor={tutor}
          formattedDate={formattedDate}
          selectedTime={selectedTime}
          onClose={() => setShowPopup(false)}
          onConfirm={handleConfirmPayment}
        />
      )}
    </PageContainer>
  );
};

export default BookingPage;
